import defaultTailwindConfig from 'tailwindcss/defaultConfig'
import { useMediaQuery } from 'react-responsive'
import Color from 'color'

import { useAppConfig } from '../../appConfig'
import movingWaldoTheme from '../themes/movingwaldo.theme'
import { ColorVariable } from './theme.types'

export const useTheme = () => {
  const { data: appConfig } = useAppConfig()
  return appConfig?.platform?.theme ?? movingWaldoTheme
}

/**
 * use a color by variable name
 */
export const useColor = (variableName: string) => {
  const theme = useTheme()
  const colorValues = theme[variableName as keyof typeof theme]
  return new Color(colorValues)
}

/**
 * return primary color
 */
export const usePrimaryColor = () => {
  return useColor(ColorVariable.Primary)
}

/**
 * return secondary color
 */
export const usePrimaryContrastColor = () => {
  return useColor(ColorVariable.PrimaryContrast)
}

/**
 * use breakpoints
 * returns a boolean if we're matching tailwind breakpoint
 */
export const useBreakpoint = (breakpointKey: string) => {
  const breakpoints = (defaultTailwindConfig.theme?.screens as Record<string, string>) ?? {}
  return useMediaQuery({
    query: breakpoints ? `(min-width: ${breakpoints[breakpointKey]})` : '',
  })
}
